﻿import * as Log from "./Log";
import { ProductName } from "../Constants";

export function wireUpClientErrorHandler(screen: string): void {
    window.onerror = (message: any, scriptUri?: string, lineNumber?: number, columnNumber?: number, error?: Error): boolean => {
        try {
            var app = ProductName;
            if ((screen !== null) && (screen.length > 0)) {
                app += " - " + screen;
            }
            const errorMessage: Log.LogEntry = {
                App: app,
                WebApp: ProductName,
                AppContext: "Web App (Client-Side)",
                MessageTemplate: "A client-side error occured in {App}: {ExceptionMessage}",
                Uri: window.location.toString(),
                ScriptUri: scriptUri,
                ExceptionMessage: message,
                LineNumber: lineNumber,
                ColumnNumber: columnNumber,
                PropertyValues: [app, message]
            };

            Log.browserClientError(errorMessage);
        } catch (e) {
            // eat it.
        }

        return false;
    };
}

export function getQueryStringParam(paramName: string): string {
    if (!location.search) {
        return "";
    }

    const query = location.search.substring(1);
    const variables = query.split("&");

    for (let i: number = 0; i < variables.length; i++) {
        const pair = variables[i].split("=");

        if (pair[0].toLowerCase() === paramName.toLowerCase()) {
            return decodeURIComponent(pair[1]);
        }
    }

    return "";
}

// Return a phone/fax number in "dotted" notation (eg. "123.456.7890" or "123.456.7890 x1234")
// If the supplied number cannot be parsed/reformatted, the supplied number will be returned.
export function formatPhoneNumber(originalNumber: string): FormatPhoneNumberResult {

    if (!originalNumber || originalNumber === "") {
        return { InputStatus: PhoneNumberStatus.NullOrBlank, Result: "" }
    } else if (originalNumber.indexOf("+") > -1) {
        return { InputStatus: PhoneNumberStatus.Unrecognized, Result: originalNumber } ;
    }

    var strippedNumber = "";
    var formattedNumber = "";
    var extension = "";

    var extensionDelimiterLocation = originalNumber.indexOf("x");

    if (extensionDelimiterLocation > 1) {
        // An extension was detected
        extension = originalNumber.substring(extensionDelimiterLocation).replace(/[^0-9]/g, '');
        strippedNumber = originalNumber.substring(0, extensionDelimiterLocation).replace(/[^0-9]/g, '');
    } else {
        strippedNumber = originalNumber.replace(/[^0-9]/g, '');
    }
        
    switch (strippedNumber.length)
    {
        case 7: 
            formattedNumber = strippedNumber.substring(0, 3) + "." + strippedNumber.substring(3, 7);
            break;
        case 10:
            formattedNumber = strippedNumber.substring(0, 3) + "." + strippedNumber.substring(3, 6) + "." + strippedNumber.substring(6, 10);
            break;
        case 11:
            if (strippedNumber.substring(0, 1) == "1")
                formattedNumber = strippedNumber.substring(1, 4) + "." + strippedNumber.substring(4, 7) + "." + strippedNumber.substring(7, 11);
            else
                formattedNumber = strippedNumber;
            break;
        default:
            // We were not able to parse this number, let's return it as-is
            return { InputStatus: PhoneNumberStatus.Unrecognized, Result: originalNumber };
    }

    if ((formattedNumber.length !== 12) && (formattedNumber.length !== 8)) {
        return { InputStatus: PhoneNumberStatus.Unrecognized, Result: originalNumber };
    }

    if (extension && extension.length > 0) {
        formattedNumber += ' x' + extension;
    }
    if (formattedNumber == originalNumber) {
        return { InputStatus: PhoneNumberStatus.AlreadyValid, Result: originalNumber };
    } else {
        return { InputStatus: PhoneNumberStatus.Reformatted, Result: formattedNumber };
    }
}

export interface FormatPhoneNumberResult {
    InputStatus: PhoneNumberStatus
    Result: string;
}

export enum PhoneNumberStatus {
    NullOrBlank,
    AlreadyValid,
    Reformatted,
    Unrecognized
}
